import "./insWaterfallDatapointChart.scss";
import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { formatPointLabel } from "../base/utils";
import { useGetWaterfallDatapointConfig } from "./helper";
import { InsWaterfallDatapointBaseChart } from "./insWaterfallDatapointBaseChart";
import { useWidgetComponentProps } from "components/widgets/hooks/use-current-widget";
import { useWaterfallLegend } from "./useWaterfallLegend";
import { InsLabelValueTooltip } from "components/widgets/base/common/insLabelValueTooltip";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
const useGetSeries = (props) => {
    const [[root], queryState] = useGetDatapointsWidgetData(props);
    const data = root?.data ?? [];
    if (data.length && "series" in data[0]) {
        return [data[0].series, queryState];
    }
    return [data, queryState];
};
const getLabelValuePairs = (context, currentViewForm, currency) => [
    [
        context.key,
        `${formatPointLabel(context.y, currentViewForm ?? ChartSelectValueFormatKind.amount, undefined, { currency, minimumFractionDigits: 2 })}`
    ]
];
export const InsWaterfallDatapointChart = (props) => {
    const [series, queryState] = useGetSeries(props);
    const configs = useGetWaterfallDatapointConfig(props, queryState, series);
    configs.options.tooltip = {
        formatter() {
            return renderToStaticMarkup(React.createElement(InsLabelValueTooltip, { labelValuePairs: getLabelValuePairs(this, configs.currentViewForm, configs.selectedCurrency) }));
        }
    };
    const widgetProps = useWidgetComponentProps(props.sectionId, props.widgetId);
    const rawLegendItems = widgetProps?.legendItems;
    const waterfallOptions = configs.options.plotOptions?.waterfall || {};
    const { legendItems, chartElementRef, renderLegend } = useWaterfallLegend({ rawLegendItems, waterfallOptions });
    if (legendItems.length) {
        configs.options.legend = { enabled: false };
    }
    return React.createElement("div", { className: "waterfallChartWithLegend" },
        React.createElement(InsWaterfallDatapointBaseChart, { widgetFactoryProps: props, configs: configs, onChartReady: (c) => {
                chartElementRef.current = c;
            } }),
        renderLegend());
};
